<template>
  <Gallery
    v-if="store.item && store.gallery"
    :id="store.item.id.split('/Product/')[1]"
    :title="store.item.title"
    :short-description="shortDescription"
    :gallery="store.gallery"
    :option="store.selected.gallery"
  />
  <Form
    v-if="store.item && loaded"
    :is-auto-bundle="true"
    location="auto-bundle-sum"
    :bnpl-message="bnplMessage"
  />
  <ProductModal
    v-if="store.edit"
    :product="store.edit"
    location="auto-bundle-modal"
  />
  <ShopTheLookNavigation v-if="shopTheLookEnabled" :terms="terms" />
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useProductStore } from './Composables/Store';
import * as Sentry from '@sentry/vue';
import { matchesSchema } from '@utils/performance';
import Form from './Form.vue';
import Gallery from './Gallery.vue';
import ProductModal from './ProductModal.vue';
import ShopTheLookNavigation from './ShopTheLookNavigation.vue';

const props = defineProps({
  terms: { type: Object, required: true, default: () => ({}) },
  handle: { type: String, required: true, default: '' },
  settings: { type: Object, required: true, default: () => ({}) },
  bnplMessage: { type: String, default: '' },
  variant: { type: [String, Number], required: false, default: '' },
  freeShippingTerms: {
    type: Object,
    default: () => ({
      banner_title: '',
      banner_copy: '',
    }),
    validator: matchesSchema({
      banner_title: 'string',
      banner_copy: 'string',
    }),
  },
});

const shortDescription = computed(() => {
  return store?.item?.shortDescription?.value ?? '';
});

const loaded = ref(false);
const handle = props?.handle?.substring(1);
const store = useProductStore();
store.mountPromoListener();

const shopTheLookEnabled = computed(() => store.shopTheLookEnabled);

onMounted(async () => {
  Sentry.addIntegration(
    Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false })
  );
  store.$state.isBundle = true;
  store.$state.isAutoBundle = true;
  store.$state.terms = props.terms;
  store.$state.settings = props.settings;
  store.$state.freeShippingTerms = props.freeShippingTerms;
  store.$state.gallery = await store.fetchGallery(handle);
  const item = await store.fetchProduct(handle);
  store.$state.item = item;
  store.$state.upsell.items = [];
  if (store.$state.item?.upsell_products) {
    store.$state.upsell.items =
      store.$state.item?.upsell_products?.value.split('|') ?? [];
  }
  await store.fetchSecondaryItemsForBundle(handle);
  await store.fetchOptionAliases();
  await store.setInititalState(props);
  loaded.value = true;
});
</script>
